(() => {
  // Care & Go / Calm Meals bundle PDP pricing remains intentionally untouched here.
  // This file also carries the mobile homepage bundle-card layout so the bundle row
  // matches the compact two-card-plus-peek behavior of the single-product row.

  const STYLE_ID = 'powlife-mobile-bundle-two-plus-peek';
  const HINT_CLASS = 'powlife-mobile-swipe-hint';

  const ensureMobileBundleStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${HINT_CLASS} {
        display: none;
      }

      @media (max-width: 749px) {
        .powlife-bundles .powlife-bundles__grid {
          display: flex !important;
          grid-template-columns: none !important;
          gap: 10px !important;
          width: 100% !important;
          max-width: none !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scroll-snap-type: x proximity;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior-inline: contain;
          padding-right: 24px !important;
          scrollbar-width: none;
        }

        .powlife-bundles .powlife-bundles__grid::-webkit-scrollbar {
          display: none;
        }

        .powlife-bundles .powlife-bundle-card {
          flex: 0 0 43.5% !important;
          width: 43.5% !important;
          min-width: 43.5% !important;
          max-width: 43.5% !important;
          scroll-snap-align: start;
        }

        .powlife-bundles .powlife-bundle-card__media {
          width: 100% !important;
          aspect-ratio: 1 / 1 !important;
        }

        .powlife-bundles .powlife-bundle-card__content {
          display: flex !important;
          flex-direction: column !important;
          min-height: 58px !important;
          padding: 7px 5px 8px !important;
        }

        .powlife-bundles .powlife-bundle-card__content h3 {
          min-height: 25px !important;
          margin: 0 0 3px !important;
          font-size: 11px !important;
          line-height: 1.14 !important;
          letter-spacing: -0.01em !important;
        }

        .powlife-bundles .powlife-bundle-card__copy {
          margin: 0 0 4px !important;
          font-size: 8.5px !important;
          line-height: 1.22 !important;
        }

        .powlife-bundles .powlife-bundle-card__copy p {
          margin: 0 !important;
        }

        .powlife-bundles .powlife-bundle-card__bottom {
          gap: 4px !important;
          margin-top: auto !important;
        }

        .powlife-bundles .powlife-bundle-card__price-wrap {
          gap: 3px !important;
          row-gap: 3px !important;
        }

        .powlife-bundles .powlife-bundle-card__compare-price {
          font-size: 8.5px !important;
          line-height: 1.15 !important;
        }

        .powlife-bundles .powlife-bundle-card__sale-price {
          font-size: 9.5px !important;
          line-height: 1.15 !important;
        }

        .powlife-bundles .powlife-bundle-card__save-pill {
          min-height: 18px !important;
          padding: 2px 5px !important;
          font-size: 8px !important;
        }

        .powlife-bundles .powlife-bundle-card__bottom > a {
          font-size: 8.5px !important;
          line-height: 1.15 !important;
          white-space: nowrap;
        }

        .powlife-bundles .powlife-bundle-card__discount-badge {
          min-height: 19px !important;
          padding: 3px 6px !important;
          font-size: 8.5px !important;
        }

        .powlife-products .powlife-product-card__meta {
          display: flex !important;
          flex-direction: column !important;
          min-height: 82px !important;
          margin-top: 3px !important;
          padding: 5px 4px 5px !important;
        }

        .powlife-products .powlife-product-card__meta h3 {
          min-height: 23px !important;
          font-size: 10.5px !important;
          line-height: 1.12 !important;
          letter-spacing: -.01em !important;
        }

        .powlife-products .powlife-product-card__meta p {
          margin-top: 1px !important;
          font-size: 9.5px !important;
          line-height: 1.1 !important;
        }

        .powlife-products .powlife-product-card__subtitle {
          min-height: 17px !important;
          margin-top: 2px !important;
          font-size: 8.5px !important;
          line-height: 1.15 !important;
        }

        .powlife-products .powlife-product-card__discount-badge {
          min-height: 19px !important;
          padding: 3px 6px !important;
          font-size: 8.5px !important;
        }

        .powlife-products .powlife-product-card__swatches {
          min-height: 14px !important;
          gap: 4px !important;
          margin-top: 4px !important;
        }

        .powlife-products .powlife-product-card__swatch {
          width: 21px !important;
          height: 13px !important;
          flex-basis: 21px !important;
        }

        .powlife-products .powlife-product-card__swatch-more {
          font-size: 8px !important;
          line-height: 13px !important;
        }

        .powlife-products .${HINT_CLASS},
        .powlife-bundles .${HINT_CLASS} {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          width: 100%;
          margin: 8px 0 0;
          color: rgba(23, 23, 23, .52);
          font-size: 10.5px;
          font-weight: 500;
          line-height: 1;
          letter-spacing: .02em;
          text-align: center;
          user-select: none;
          pointer-events: none;
        }

        .powlife-products .${HINT_CLASS}__arrow,
        .powlife-bundles .${HINT_CLASS}__arrow {
          display: inline-block;
          font-size: 14px;
          line-height: 1;
          transform: translateY(-.5px);
        }
      }
    `;

    document.head.appendChild(style);
  };

  const ensureSwipeHints = () => {
    const targets = [
      document.querySelector('.powlife-products .powlife-products__grid'),
      document.querySelector('.powlife-bundles .powlife-bundles__grid')
    ].filter(Boolean);

    targets.forEach(grid => {
      if (grid.nextElementSibling?.classList.contains(HINT_CLASS)) return;
      const hint = document.createElement('div');
      hint.className = HINT_CLASS;
      hint.setAttribute('aria-label', 'Swipe horizontally to see more');
      hint.innerHTML = `<span>Swipe for more</span><span class="${HINT_CLASS}__arrow" aria-hidden="true">→</span>`;
      grid.insertAdjacentElement('afterend', hint);
    });
  };

  const init = () => {
    ensureMobileBundleStyles();
    ensureSwipeHints();
  };

  init();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
  document.addEventListener('shopify:section:load', init);
})();
